<template>
    <div v-if="show" class="ai-review-overlay" @click="$emit('close')">
      <div class="ai-review-content" @click.stop>
        <div class="ai-review-header ai-review-header-container">
          <div class="ai-review-title">
            <span class="ai-review-icon">🤖</span>
            <span>AI 点评</span>    
          </div>
          <div class="ai-review-actions">
            <button class="action-icon-button delete-button" @click="$emit('delete')" title="删除AI点评">
              <span class="action-icon">🗑️</span>
            </button>
            <button class="action-icon-button close-button" @click="$emit('close')" title="关闭">
              <span class="action-icon">✕</span>
            </button>
          </div>
        </div>
        <div class="ai-review-body">
          <div v-if="loading" class="ai-review-loading">
            <div class="spinner"></div>
            <p>AI 正在分析文章...</p>
          </div>
          <div v-else-if="content" class="ai-review-text">
            <div v-html="formatAIReview(content)"></div>
          </div>
        </div>
      </div>
    </div>
</template>

<script setup>
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */

defineProps({
    show: Boolean,
    content: String,
    loading: Boolean
});

defineEmits(['close', 'delete']);

const formatAIReview = (content) => {
    if (!content) return '';
    let c = content;
    // Simple markdown formatter
    c = c.replace(/^### (.*)$/gm, '<h4>$1</h4>');
    c = c.replace(/^## (.*)$/gm, '<h3>$1</h3>');
    c = c.replace(/^# (.*)$/gm, '<h2>$1</h2>');
    c = c.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
    c = c.replace(/\*(.*?)\*/g, '<em>$1</em>');
    c = c.replace(/^(\d+)\. (.*)$/gm, '<li>$2</li>');
    c = c.replace(/^\s*[*-] (.*)$/gm, '<li>$1</li>');
    c = c.replace(/\n{2,}/g, '</p><p>');
    c = '<p>' + c + '</p>';
    c = c.replace(/(<li>.*?<\/li>)/gs, '<ul>$1</ul>');
    return c;
};
</script>

<style scoped>
@import '@/assets/styles/AppLayout.css';
</style>
